import { makeRequest } from '../../../api/makeRequest';

export const getDeactivationStatus = (id) => makeRequest({
  url: '/limitFamily/deactivateByChildStatus/',
  params: {
    requestId: id,
  },
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});
